import { Box, Typography } from '@mui/material';

import styles from './SpotGuideMoreInfo.module.scss';

interface Props {
  spotName: string;
}

const SpotGuideMoreInfo = ({ spotName }: Props) => (
  <Box className={styles.moreInfo} data-testid="spot-guide-more-info">
    <Typography variant="callout1" component="p">
      Do you have local knowledge about {spotName}?
    </Typography>
    <Typography variant="callout2" component="p">
      If you have any insights or information to add to this spot guide, drop us a note at{' '}
      <a href={`mailto:support@surfline.com?subject=${spotName} Spot Guide`}>
        support@surfline.com
      </a>{' '}
    </Typography>
  </Box>
);

export default SpotGuideMoreInfo;
